import { render, staticRenderFns } from "./RichEditor.vue?vue&type=template&id=8e5ebf18&scoped=true"
import script from "./RichEditor.vue?vue&type=script&lang=js"
export * from "./RichEditor.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./styles/rich-editor.less?vue&type=style&index=1&id=8e5ebf18&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5ebf18",
  null
  
)

export default component.exports